import {initialQueryState} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useColumnVisibility} from '../../core/ColumnVisibilityProvider'
import {TaskFilterBar} from '../../../shared/task-filter-bar/TaskFilterBar'
import {TaskFilterValue} from '../../../shared/task-filter-bar/types'
import {TasksByUserExportButton} from './TasksByUserExportButton'

const TasksByUserListHeader = () => {
  const {state, updateState} = useQueryRequest()
  const {hideDatesColumn, setHideDatesColumn} = useColumnVisibility()

  return (
    <TaskFilterBar
      scope='byUser'
      hideDatesColumn={hideDatesColumn}
      onHideDatesColumnChange={setHideDatesColumn}
      onSearchChange={(term) => updateState({search: term, ...initialQueryState})}
      onApply={(filter: Partial<TaskFilterValue>) =>
        updateState({filter: {...(state.filter as object), ...filter}})
      }
      exportButton={<TasksByUserExportButton />}
    />
  )
}

export {TasksByUserListHeader}
